






import { Provide, Component, Vue } from 'vue-property-decorator'

@Component
export default class CompanySettingsNarrowcastingOffices extends Vue {

    @Provide()
    navigateToList(): void {
        document.querySelector('.main').scrollTo({ top: 0 })
        this.$router.push({
            name: 'company_settings_narrowcasting_offices_list',
        })
    }

    @Provide()
    navigateToCreate(): void {
        document.querySelector('.main').scrollTo({ top: 0 })
        this.$router.push({
            name: 'company_settings_narrowcasting_offices_create',
        })
    }

    @Provide()
    navigateToEdit(officeId: string): void {
        document.querySelector('.main').scrollTo({ top: 0 })
        this.$router.push({
            name: 'company_settings_narrowcasting_offices_edit',
            params: {
                officeId,
            },
        })
    }
}
